<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            v-bind:href="'#t2' + rowData.ciot_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Valor da Pré Fatura
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t3' + rowData.ciot_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="
              rowData.carga_ciot.length > 0 &&
              rowData.carga_ciot[0].carga.carga_doc[0].doc_fiscal
                .doc_transp_docfis != null &&
              rowData.carga_ciot[0].carga.carga_doc[0].doc_fiscal
                .doc_transp_docfis.doc_transp.pre_fatura_despesa_doc[0]
                .pre_fatura_despesa.fatura_despesa != null
            "
          >
            <span class="nav-link-in">
              Valor da Fatura
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t4' + rowData.ciot_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Valor da Fatura
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t5' + rowData.ciot_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
             Carga associadas
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <div
          role="tabpanel"
          class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
          v-bind:id="'t2' + rowData.ciot_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 30%">N° Fiscal</th>
                <th style="width: 30%">Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="(item, i) in rowData.carga_ciot"
              >
                <td>
                  <span
                    v-if="
                      item.carga.carga_doc[0].doc_fiscal.doc_transp_docfis !=
                        null &&
                      item.carga.carga_doc[0].doc_fiscal.doc_transp_docfis
                        .doc_transp.pre_fatura_despesa_doc.length > 0
                    "
                  >
                    {{
                      item.carga.carga_doc[0].doc_fiscal.doc_transp_docfis
                        .doc_transp.pre_fatura_despesa_doc[0].pre_fatura_despesa
                        .num_fiscal
                    }}
                  </span>
                  <span
                    v-if="
                      item.carga.carga_doc[0].doc_fiscal.doc_transp_docfis ==
                      null
                    "
                  >
                    Sem dados registrados
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      item.carga.carga_doc[0].doc_fiscal.doc_transp_docfis !=
                        null &&
                      item.carga.carga_doc[0].doc_fiscal.doc_transp_docfis
                        .doc_transp.pre_fatura_despesa_doc.length > 0
                    "
                  >
                    {{
                      formatNumber(
                        item.carga.carga_doc[0].doc_fiscal.doc_transp_docfis
                          .doc_transp.pre_fatura_despesa_doc[0]
                          .pre_fatura_despesa.vlr_pre_fatura
                      )
                    }}
                  </span>
                  <span
                    v-if="
                      item.carga.carga_doc[0].doc_fiscal.doc_transp_docfis ==
                      null
                    "
                  >
                    Sem dados registrados
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fadept-1 border-color-detalhes-grey"
          v-bind:id="'t3' + rowData.ciot_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 30%">N° Fiscal</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="(item, i) in rowData.carga_ciot"
              >
                <td>
                  <span
                    v-if="
                      item.carga.carga_doc[0].doc_fiscal
                        .doc_transp_docfis != null &&
                      item.carga.carga_doc[0].doc_fiscal
                        .doc_transp_docfis.doc_transp.pre_fatura_despesa_doc[0]
                        .pre_fatura_despesa != null &&
                      item.carga.carga_doc[0].doc_fiscal
                        .doc_transp_docfis.doc_transp.pre_fatura_despesa_doc[0]
                        .pre_fatura_despesa.fatura_despesa != null
                    "
                  >
                    {{
                      item.carga.carga_doc[0].doc_fiscal.doc_transp_docfis
                        .doc_transp.pre_fatura_despesa_doc[0].pre_fatura_despesa
                        .fatura_despesa.num_fiscal
                    }}
                  </span>
                  <span
                    v-if="
                      item.carga.carga_doc[0].doc_fiscal.doc_transp_docfis ==
                      null
                    "
                  >
                    Sem dados registrados
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t4' + rowData.ciot_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 30%">N° Fiscal</th>
                <th style="width: 30%">Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="(item, i) in rowData.carga_ciot"
              >
                <td>
                  <span
                    v-if="
                      item.carga.carga_doc[0].doc_fiscal.doc_transp_docfis !=
                        null &&
                      item.carga.carga_doc[0].doc_fiscal.doc_transp_docfis
                        .doc_transp.pre_fatura_despesa_doc.length > 0 &&
                      item.carga.carga_doc[0].doc_fiscal.doc_transp_docfis
                        .doc_transp.pre_fatura_despesa_doc[0].pre_fatura_despesa != null &&
                      item.carga.carga_doc[0].doc_fiscal.doc_transp_docfis
                        .doc_transp.pre_fatura_despesa_doc[0].pre_fatura_despesa.fatura_despesa != null                
                    "
                  >
                    {{
                      item.carga.carga_doc[0].doc_fiscal.doc_transp_docfis
                        .doc_transp.pre_fatura_despesa_doc[0].pre_fatura_despesa
                        .fatura_despesa.num_fiscal
                    }}
                  </span>
                  <span
                    v-if="
                      item.carga.carga_doc[0].doc_fiscal.doc_transp_docfis ==
                      null ||
                       item.carga.carga_doc[0].doc_fiscal.doc_transp_docfis
                        .doc_transp.pre_fatura_despesa_doc[0].pre_fatura_despesa.fatura_despesa == null
                    "
                  >
                    Sem dados registrados
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      item.carga.carga_doc[0].doc_fiscal.doc_transp_docfis !=
                        null &&
                      item.carga.carga_doc[0].doc_fiscal.doc_transp_docfis
                        .doc_transp.pre_fatura_despesa_doc.length > 0 &&
                      item.carga.carga_doc[0].doc_fiscal.doc_transp_docfis
                        .doc_transp.pre_fatura_despesa_doc[0].pre_fatura_despesa != null &&
                      item.carga.carga_doc[0].doc_fiscal.doc_transp_docfis
                        .doc_transp.pre_fatura_despesa_doc[0].pre_fatura_despesa.fatura_despesa != null  
                    "
                  >
                    {{
                      formatNumber(
                        item.carga.carga_doc[0].doc_fiscal.doc_transp_docfis
                          .doc_transp.pre_fatura_despesa_doc[0]
                          .pre_fatura_despesa.fatura_despesa.vlr_fatura
                      )
                    }}
                  </span>
                  <span
                    v-if="
                      item.carga.carga_doc[0].doc_fiscal.doc_transp_docfis ==
                      null ||
                       item.carga.carga_doc[0].doc_fiscal.doc_transp_docfis
                        .doc_transp.pre_fatura_despesa_doc[0].pre_fatura_despesa.fatura_despesa == null
                    "
                  >
                    Sem dados registrados
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t5' + rowData.ciot_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 100%">N° Carga</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="(item, i) in rowData.carga_ciot"
              >
                <td>
                  {{item.carga.num_carga}}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
      </div>
      <!--.tab-content-->
    </div>
  </div>
</template>

<script>
import accounting from "accounting";
export default {
  data() {
    return {
      helpForm: new Form({ statusRecord: [], params: [] }),
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  methods: {
    onEditPercursoUfOrdem(data) {
      this.$parent.$parent.onEditPercursoUfOrdem(data);
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
  },
};
</script>
